import _toConsumableArray from "/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export function listenKeys(store, keys, listener) {
  var keysSet = new Set([].concat(_toConsumableArray(keys), [undefined]));
  return store.listen(function (value, changed) {
    if (keysSet.has(changed)) {
      listener(value, changed);
    }
  });
}